<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-2",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 2,
      nextPage: '/questionnaire/section1/3',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        mainTitle: 'Are you:',
        btn: [[{
          text: 'Female'
        }],
        [{
          text: 'Male'
        }],
        [{
          text: 'Non-binary'
        }]]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
